/*! @azure/msal-common v15.5.0 2025-04-08 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.5.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
